import { useSearchParams } from "react-router-dom";
import PurchasePageTitle from "../../components/PurchasePageTitle";
import NewCreditCardDataSection from "../../components/NewCreditCardDataSection";
import useTransaction from "../../hooks/useTransaction";
import { useEffect } from "react";
import { useUser } from "../../../../../contexts/userContext/userContext";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import useExpirationTimer from "./hooks/useExpirationTimer";

const PurchaseCheckout = () => {
  const [searchParams] = useSearchParams();
  const t = searchParams.get("t");
  const token = searchParams.get("token");
  const isDowngrade = !!searchParams.get("isDowngrade");
  const {
    fetchNewCreditCardIframeUrl,
    newCreditCardIframeUrlError,
    checkIfSubscriptionPurchase,
  } = useTransaction();
  const { isLoggedIn, getIsPendingLogin } = useUser();
  const { getPath } = useContent();

  // Redirect to error page after 20 minutes
  useExpirationTimer();

  useEffect(() => {
    if (!isLoggedIn() && !getIsPendingLogin()) {
      window.location.href = `${getPath()}error`;
    }
  }, [isLoggedIn(), getIsPendingLogin()]);

  useEffect(() => {
    if (t && token) {
      fetchNewCreditCardIframeUrl({ token, t, isDowngrade });
    } else if (!t && !token) {
      window.location.href = window.location.origin + `${getPath()}home`;
    }
  }, [
    fetchNewCreditCardIframeUrl,
    token,
    t,
    isDowngrade,
    checkIfSubscriptionPurchase,
  ]);

  // Redirect to purchase failed page if there is an error
  useEffect(() => {
    if (newCreditCardIframeUrlError) {
      window.location.href = `purchase-failed?t=${t}&token=${token}&reason=${newCreditCardIframeUrlError}`;
    }
  }, [newCreditCardIframeUrlError]);

  // Show nothing for this page if there is an error
  if (newCreditCardIframeUrlError) return null;

  return (
    <div>
      <PurchasePageTitle />
      <NewCreditCardDataSection />
    </div>
  );
};

export default PurchaseCheckout;
